import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface CreateShortUrlRequest {
  emailAddress: string;
  opportunityId: string;
  dealerId: string;
  analytics?: boolean;
}

export interface CreateShortUrlResponse {
  statusCode: number;
  message: string;
  statusText: string;
  body: {
    shortUrl: string;
    details: {
      emailAddress: string;
      opportunityId: string;
      dealerId: string;
    };
  };
}

class NurturingHistory {
  static ENDPOINT = 'api/v2/nurturing/history';

  static async createShortUrl(payload: CreateShortUrlRequest): Promise<APIResponseType<CreateShortUrlResponse>> {
    try {
      const response = await apiService.post<CreateShortUrlResponse>(
        `${this.ENDPOINT}/short-url`,
        payload,
        {},
        false // Disable caching for this operation
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static extractUrlId(shortUrl: string): string | null {
    try {
      // Extract ID from URL like "https://app.myautoiq.net/url/6862c7e2868e70732edda356"
      const match = shortUrl.match(/\/url\/([^/?]+)/);
      return match ? match[1] : null;
    } catch (error) {
      console.error('Error extracting URL ID:', error);
      return null;
    }
  }

  static buildRedirectUrl(urlId: string): string {
    // Use the current domain instead of API URL
    const currentDomain = window.location.origin;
    return `${currentDomain}/url/${urlId}`;
  }
}

export default NurturingHistory; 